import { createContext, use, useContext } from 'react';
import { login, logout, register } from 'services/auth';
import { useAuthManager } from './useAuthManager';
import { useInviteCode } from './useInviteCode';
import { UserProvider } from '../';

const Auth = createContext();

export const AuthProvider = ({ children }) => {
  const { loading, user } = useAuthManager();
  const isAuthenticated = Boolean(user?.uid) && !loading;
  const inviteCode = useInviteCode();

  return (
    <Auth.Provider
      value={{
        inviteCode,
        isAuthenticated,
        loading,
        login,
        logout,
        register,
        user,
      }}
    >
      <UserProvider uid={user?.uid}>{children}</UserProvider>
    </Auth.Provider>
  );
};

export const useAuth = () => useContext(Auth);
